import React from 'react'
import { List } from 'tea-component'

import { useConstant } from '../../constants'

const SelectPanel = (props) => {
  const {
    close,
    activeItem,
    onSelectChange
  } = props
  const { SELECT_LIST } = useConstant()
  
  return (
    <List 
      type="option"
      className='dtb-db-tracking-day__list'
      boxClassName='dtb-db-tracking-day__list-box'
    >
      {
        SELECT_LIST?.map(item => (
          <List.Item
            key={item?.id}
            current={item?.id === activeItem?.id}
            onClick={() => onSelectChange(item, close)}
          >
            {item.name}
          </List.Item>
        ))
      }
    </List>
  )
}

export default SelectPanel